import { LucideIcon } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { StepHeader } from "./StepHeader";

interface GoalStepProps {
  icon: LucideIcon;
  title: string;
  description: string;
  goal: string;
  setGoal: (value: string) => void;
  specificGoal: string;
  setSpecificGoal: (value: string) => void;
}

const GOAL_SUGGESTIONS = ["Lose 20 lbs", "Get visible abs", "Bench 225", "Deadlift 405", "Run a 5K"];

export function GoalStep({
  icon,
  title,
  description,
  goal,
  setGoal,
  specificGoal,
  setSpecificGoal,
}: GoalStepProps) {
  return (
    <div className="w-full max-w-sm animate-fade-in space-y-4">
      <StepHeader icon={icon} title={title} description={description} />

      <div className="space-y-3">
        <div className="space-y-1.5">
          <Label htmlFor="goal" className="text-xs">Primary Goal</Label>
          <Select value={goal} onValueChange={setGoal}>
            <SelectTrigger className="bg-secondary/30 border-border/50 h-9">
              <SelectValue placeholder="Select your goal" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="lose-fat">Lose Fat</SelectItem>
              <SelectItem value="build-muscle">Build Muscle</SelectItem>
              <SelectItem value="get-stronger">Get Stronger</SelectItem>
              <SelectItem value="recomp">Recomp (lose fat + build muscle)</SelectItem>
              <SelectItem value="improve-endurance">Improve Endurance</SelectItem>
              <SelectItem value="general-fitness">General Fitness</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="specificGoal" className="text-xs">Specific Target (be exact!)</Label>
          <Textarea
            id="specificGoal"
            placeholder="e.g., 'Lose 20 lbs by summer', 'Visible abs by July', 'Deadlift 4 plates', 'Add 100 lbs to my total'"
            value={specificGoal}
            onChange={(e) => setSpecificGoal(e.target.value)}
            className="bg-secondary/30 border-border/50 min-h-[80px] resize-none"
          />
        </div>

        {/* Quick goal suggestions */}
        <div className="flex flex-wrap gap-2">
          {GOAL_SUGGESTIONS.map((suggestion) => (
            <button
              key={suggestion}
              onClick={() => setSpecificGoal(suggestion)}
              className="px-2.5 py-1 text-xs bg-secondary/50 border border-border/50 rounded-full hover:bg-secondary hover:border-primary/30 transition-all"
            >
              {suggestion}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
